<template>
  <v-dialog v-model="dialogOpen" :persistent="true" max-width="600px">
    <v-form>
      <v-card>
        <v-card-title>
          <h4><v-icon>mdi-folder</v-icon>Produkt</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="name"
            label="Bezeichnung"
            required
            :rules="rules"
          />
          <v-text-field
            v-model="patternNumber"
            label="Haushaltsstelle"
            required
            :rules="rules"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="default" text @click="close" :disabled="actionsDisabled">Abbrechen</v-btn>
          <v-btn v-if="isExistingProduct && product.isActive" color="error" class="white--text" @click="setInactive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye-off</v-icon> Deaktivieren
          </v-btn>
          <v-btn v-else-if="isExistingProduct" color="success" class="white--text" @click="setActive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye</v-icon> Aktivieren
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid || actionsDisabled" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import timeparkApi from "@/timeparkApi";
const productsApi = timeparkApi.productsApi;

export default {
  name: 'ProductDialog',
  props: {
    open: Boolean,
    product: Object,
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open;
      },
      set(v) {
        this.$emit('update:open', v);
      }
    },
    isChangingActive() {
      return this.runningOperation === 'changeActive';
    },
    isSaving() {
      return this.runningOperation === 'save';
    },
    actionsDisabled() {
      return !!this.runningOperation;
    },
    valid() {
      return !!this.name && !! this.patternNumber;
    },
    isExistingProduct() {
      return this.product && this.product.id;
    }
  },
  watch: {
    product: {
      deep: true,
      handler: 'updateData'
    }
  },
  methods: {
    async setInactive() {
      this.runningOperation = 'changeActive';

      await productsApi.deactivateProduct(this.product.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async setActive() {
      this.runningOperation = 'changeActive';

      await productsApi.reactivateProduct(this.product.id);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    async save() {
      const product = {
        id: this.product ? this.product.id : null,
        number: this.number,
        patternNumber: this.patternNumber,
        name: this.name,
      };
      const apiOperation = product.id ?
          productsApi.editProduct :
          productsApi.createProduct;
      this.runningOperation = 'save';

      await apiOperation(product);
      await this.$store.dispatch('loadProducts');

      this.runningOperation = null;
      this.close();
    },
    close() {
      this.updateData(null);
      this.$emit('close');
    },
    updateData(data) {
      this.name = data ? data.name : '';
      this.number = data ? data.number : null;
      this.patternNumber = data ? data.patternNumber : null;
    },
  },
  data() {
    return {
      name: '',
      number: null,
      patternNumber: null,
      rules: [val => !!val || 'Dieses Feld darf nicht leer sein'],
      runningOperation: null,
    };
  },
};
</script>
